import React from "react";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import MainDropdownInput from "components/MainApp/atoms/Forms/MainDropdown";
import DragAndDropImages from "components/MainApp/atoms/Forms/DragAndDropImages";

import styles from "./DeviceForm.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";
import { FILE_TYPE_VIDEO_ALLOWED } from "constants";

const AddLocationForm = ({
  device,
  handleSelect,
  handleChange,
  error,
  zones,
  sectors,
  nodes,
  type,
  disabledFields,
  handleChangeImage,
  handleDeleteImage,
  showSelectorFiles = true,
  msgInfoFiles= ''
}) => {
    return (
    <div className={styles["edit-device-form-content"]}>
      <div
        className={styles["edit-device-form-field"]}
        data-automation-id="input-serial_number"
      >
        <MainInput
          label={i18n.t("serial.number")}
          required={true}
          id={"device-serial_number"}
          name="serial_number"
          value={device ? device.serial_number : ''}
          handleChange={handleChange}
          disabled={disabledFields && disabledFields.includes('serial_number')}
          maxLength={100}
          error={error.serial_number && error.serial_number}
        />
      </div>
      {type !== 'device' && <div
        className={styles["edit-device-form-field"]}
        data-automation-id="input-serial_number"
      >
        <MainInput
          label={i18n.t("port")}
          required={true}
          id={"device-port"}
          name="port"
          value={device ? device.port : ""}
          handleChange={handleChange}
          maxLength={100}
          disabled={disabledFields && disabledFields.includes('port')}
          error={error.port && error.port}
        />
      </div>}

      <div
        className={styles["edit-device-form-field"]}
        data-automation-id="input-name"
      >
        <MainInput
          label={capitalize(i18n.t("name"))}
          required={true}
          id={"device-name"}
          name="name"
          value={device ? device.name : ""}
          handleChange={handleChange}
          maxLength={100}
          disabled={disabledFields && disabledFields.includes('name')}
          error={error.name && error.name}
        />
      </div>
      <div
        className={styles["edit-device-form-field"]}
        data-automation-id="input-node"
      >
        <MainDropdownInput
          required={true}
          id={"device-node"}
          name="node"
          selectedOption={device ? device.node : ""}
          handleSelection={(selectedOption) =>
            handleSelect(selectedOption, "node")
          }
          maxLength={50}
          options={nodes}
          placeholder={i18n.t("branch.office")}
          label={i18n.t("branch.office")}
          disabled={disabledFields && disabledFields.includes('node')}
          error={error.node && error.node}
        />
      </div>
      <div
        className={styles["edit-device-form-field"]}
        data-automation-id="input-zone"
      >
        <MainDropdownInput
          id={"device-zone"}
          name="zone"
          selectedOption={device ? device.zone : ""}
          handleSelection={(selectedOption) => {
            handleSelect(selectedOption, "zone");
          }}
          maxLength={50}
          options={zones}
          placeholder={i18n.t("zone")}
          label={i18n.t("zone")}
          disabled={(!device || !device.node || device.node === "") || (disabledFields && disabledFields.includes('zone'))}
          error={error.zone && error.zone}
        />
      </div>
      <div
        className={styles["edit-device-form-field"]}
        data-automation-id="input-sectors"
      >
        <MainDropdownInput
          required={false}
          id={"device-sectors"}
          name="sectors"
          selectedOption={device ? device.area : ""}
          handleSelection={(selectedOption) => {
            handleSelect(selectedOption, "sector");
          }}
          maxLength={50}
          options={sectors}
          placeholder={capitalize(i18n.t("sector"))}
          label={capitalize(i18n.t("sector"))}
          disabled={(!device || !device.zone || device.zone === "") || (disabledFields && disabledFields.includes('sector'))}
          error={error.area && error.area}
        />
      </div>

      {device && (device?.device_type?.type === 'LIFT' || device?.device_type?.type === 'FITTING') &&
          <div className={styles["edit-device-form-field"]} data-automation-id="input-image">
            <DragAndDropImages
              name="image"
              handleChange={handleChangeImage}
              handleDelete={handleDeleteImage}
              files={device.item_file ? [device.item_file] : []}
              showSelectorFiles={showSelectorFiles}
              msgInfoFiles={msgInfoFiles}
              msg={i18n.t("drag.video.here")}
              showStar={false}
              fileTypeAccepted={FILE_TYPE_VIDEO_ALLOWED}
            />
          </div>
        }
    </div>
  );
};

export default AddLocationForm;
